import { render, staticRenderFns } from "./upcoming-activities-container.vue?vue&type=template&id=07d1ea24"
import script from "./upcoming-activities-container.vue?vue&type=script&lang=js"
export * from "./upcoming-activities-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports